import { apiBaseUrl } from './services/httpClient';

const config = {
  app: {
    name: 'Mokorotlo College Of Creative Technology',
    shortName: 'MCCT',
    version: '1.0.0',
    copyright: `© ${new Date().getFullYear()} Mokorotlo College Of Creative Technology. All rights reserved.`,
  },
  api: {
    baseUrl: apiBaseUrl,
  },
  theme: {
    default: 'light',
  },
};

export default config;
